// extracted by mini-css-extract-plugin
export default {"numberOfDays":"fZ78cU0AUX9UMRmDpHun"};